import { render } from "./entity_verification_results.html?vue&type=template&id=489c18f0&scoped=true&external"
import script from "./entity_verification_results.js?vue&type=script&lang=js&external"
export * from "./entity_verification_results.js?vue&type=script&lang=js&external"

import "./EntityVerificationResults.vue?vue&type=style&index=0&id=489c18f0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489c18f0"]])

export default __exports__